<div *ngIf="data != null" class="attach-order-files-modal__wrapper">
  <wl-attach-order-files
    (attached)="anyFilesChanged = true"
    (removed)="anyFilesChanged = true"
    [files]="files"
    [typeFile]="data.typeFile"
    [showAllFiles]="true"
    [order]="data.order"
    [isRedesignAttachment]="data.isRedesignAttachment"
    (progress)="onProgress($event)"
  />
</div>

<div class="attach-order-files-modal__footer">
  <p-button
    [disabled]="anyInProgressFiles || posting"
    severity="secondary"
    size="small"
    [label]="'general.close' | translate"
    (onClick)="onClose()"
  />
  <p-button
    [loading]="posting"
    [disabled]="!hasFiles || anyInProgressFiles || posting"
    severity="primary"
    size="small"
    (onClick)="onPost()"
  >
    <mat-icon svgIcon="wl:send" />
    <span>{{ 'general.post' | translate }}</span>
  </p-button>
</div>
